import React, { useState } from "react";
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css'; 

export function HtmlEditor({ strategieTemp = "", onContentChange}) {

    const [quillText, setQuillText] = useState(strategieTemp);
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ align: [] }],
        
            [{ list: 'ordered'}, { list: 'bullet' }],
            [{ indent: '-1'}, { indent: '+1' }],
        
            [{ size: ['small', false, 'large'] }],
          ],
      };

    const { quill, quillRef } = useQuill({modules, placeholder:"Write your strategy"});
    React.useEffect(() => {
        if (quill) {
            if (quillText !== "") {
                quill.clipboard.dangerouslyPasteHTML(quillText);
            }

            quill.on('text-change', () => {
                setQuillText(quill.root.innerHTML)
                onContentChange(quill.root.innerHTML)
                });
        }
        // eslint-disable-next-line
      }, [quill]);

    return(
        <div style={{ width: "55%", height: 300, marginBottom: 50 }}>
            <div ref={quillRef} />
        </div>
    );
}
export default HtmlEditor;